import Vue from 'vue'
import VueResource from 'vue-resource'
import VueProgressiveImage from 'vue-progressive-image'
import VueLazyload from 'vue-lazyload'
import VueAnalytics from 'vue-analytics'

import App from './App'
import router from './router'
import store from './store'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import firebase from '@firebase/app'
import '@firebase/auth'
import urlHelpers from '@/router/urlHelpers'
import './serviceworker'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue: Vue,
    dsn: 'https://95a3c478b0b34d76b9791404eb7fb189@sentry.io/124726',
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    tracingOptions: {
      trackComponents: true
    }
  })
}

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(VueProgressiveImage)
Vue.use(VueLazyload)
Vue.use({
  install () {
    Vue.urlHelpers = urlHelpers
    Vue.prototype.$urlHelpers = urlHelpers
  }
})

let vueAnalyticsOptions = { id: 'UA-112400907-1' }
if (process.env.NODE_ENV === 'development') {
  Object.assign(vueAnalyticsOptions, {
    debug: {
      enabled: true,
      trace: false,
      sendHitTask: false
    }
  })
}
Vue.use(VueAnalytics, vueAnalyticsOptions)
/* eslint-disable */
!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src=("https:"===document.location.protocol?"https://":"http://")+"cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(n,o);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
}}();
/* eslint-enable */
window.analytics.load(process.env.SEGMENT_WRITE_KEY)
Vue.prototype.$track = (ev, props) => {
  window.analytics.track(ev, Object.assign({}, props, {
    device: JSON.parse(JSON.stringify(store.state.device))
  }))
}

Vue.prototype.$hasFeatureAccess = (feature) => {
  try {
    let features = store.state.User.preferences.features
    let identifiers = Object.keys(features)
    let available = identifiers.filter(id => features[id])
    return available.indexOf(feature) !== -1
  } catch (e) {
    return false
  }
}
Vue.prototype.$preference = (preference) => {
  try {
    let preferences = store.state.User.preferences
    return preferences[preference]
  } catch (e) {
    return false
  }
}

Vue.prototype.$log = (ev) => {
  const xhr = new XMLHttpRequest()
  let uri
  if (process.env.NODE_ENV === 'development') {
    uri = `https://${process.env.FIREBASE_AUTH_DOMAIN}/l`
    console.log('firebase uri', uri)
  } else {
    uri = '/l'
  }
  const serialize = (obj) => {
    // eslint-disable-next-line
    return Object.keys(obj).reduce((a,k)=>{a.push(k+'='+encodeURIComponent(obj[k]));return a},[]).join('&')
  }

  xhr.open('POST', uri, true)
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
  xhr.onload = () => {}
  firebase.auth().currentUser.getIdToken().then(idToken => {
    const params = serialize({ ev, idToken })
    xhr.send(params)
  })
}

let app
const FIREBASE_CONFIG = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID
}
firebase.initializeApp(FIREBASE_CONFIG)
/* eslint-disable no-new, no-unused-vars */
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      http: {},
      components: { App },
      template: '<App/>'
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js